const user_en = {
  title: 'Users',
  subtitle: 'User Management',
  searchPlaceholder: 'Search',
  addNewUser: 'Add New User',
  updateUser: 'Update User',
  cancel: 'Cancel',
  table: {
    name: 'Name',
    email: 'Email',
    role: 'Role',
    organization: 'Organization',
    laConceptContactPerson: 'LA Concept Contact Person',
    lastChange: 'Last Change',
    status: 'Status',
    actions: 'Actions',
    active: 'Active',
    inactive: 'Inactive',
  },
  message: {
    created: 'User was created',
    createError: 'User create was failed',
    updated: 'User was updated',
    updateError: 'User update was failed',
  },
  form: {
    createTitle: 'Add New User',
    updateTitle: 'Edit User',
    firstName: 'First Name',
    firstNamePlaceholder: 'Enter First Name',
    lastName: 'Last Name',
    lastNamePlaceholder: 'Enter Last Name',
    email: 'Email Address',
    emailPlaceholder: 'Enter Email Address',
    phoneNumber: 'Phone Number',
    phoneNumberPlaceholder: 'Enter Phone Number',
    phoneNumberInvalid: 'Please enter a valid phone number',
    position: 'Position',
    positionPlaceholder: 'Enter Position',
    password: 'Password',
    passwordPlaceholder: 'Enter Password',
    role: 'Role',
    rolePlaceholder: 'Select Role',
    emailRequired: 'Email is required',
    emailInvalid: 'Email is invalid',
    firstNameRequired: 'First Name is required',
    lastNameRequired: 'Last Name is required',
    passwordRequired: 'Password is required',
    roleRequired: 'Role is required'
  },
  delete: {
    title: 'Delete User',
    body: 'Are you sure you want to delete this user?',
    cancel: 'Cancel',
    delete: 'Delete',
    success: 'User was deleted',
    fail: 'User delete was failed'
  },
  detail: {
    back: 'Back',
    editUser: 'Edit User',
    deleteUser: 'Delete User',
    sendResetEmail: "Send Reset Email"
  }
}

export default user_en
